"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _themeUi = require("theme-ui");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/** @jsx jsx */
var AspectRatio = React.forwardRef(function (props, ref) {
  return (0, _themeUi.jsx)(_themeUi.AspectRatio, (0, _tslib.__assign)({
    ref: ref
  }, props));
});
AspectRatio.displayName = 'AspectRatio';
var _default = AspectRatio;
exports.default = _default;